import { atom, selector, selectorFamily } from "recoil";
import { latestReceiveMessageFamily, messageAircraftIds } from "./MessageState";
import { isEqualObject } from "../utils/FPEUtils";
import axios from "axios";
import { COMMUNICATE_ERROR_COPILOT_TOOLTIP_SETTINGS } from "../constants/ErrorMessage";

export const coPilotFocusTargetState = atom({
  key: 'coPilotFocusTargetState',
  default: ""
});

export const coPilotDetailViewState = atom({
  key: 'coPilotDetailViewState',
  default: false
});

export const coPilotDetailTargetState = atom({
  key: 'coPilotDetailTargetState',
  default: ""
});

export const csTargetState = atom({
  key: 'csTargetState',
  default: {}
});

export const navLogTargetState = atom({
  key: 'navLogTargetState',
  default: ''
});

export const coPiPositionDataAll = atom({
  key: 'coPiPositionDataAll',
  default: []
});

export const activeAlertTargetState = atom({
  key: 'activeAlertTargetState',
  default: ''
});

export const coPiPositionDataById = selectorFamily({
  key: 'coPiPositionDataById',
  get: id => ({get}) => {
    const all = get(coPiPositionDataAll);
    return all.find(r => r.id === id);
  }
});

export const coPiAllAircraftCodeSelector = selector({
  key: 'coPiAllAircraftCodeSelector',
  get: ({get}) => {
    const allCoPi = get(coPiPositionDataAll);
    return allCoPi.map(coPi => coPi.id);
  }
});

export const coPiMessagesSelector = selectorFamily({
  key: 'coPiMessagesSelector',
  get: ({targets, userGroup}) => ({get}) => {
    //コミュボ対象のaircraft_code
    const messageAircraftCodeList = get(messageAircraftIds(userGroup)).filter(aircraftCode => targets.includes(aircraftCode));
    const list = []
    messageAircraftCodeList.forEach(target => {
      const message = get(latestReceiveMessageFamily(target));
      list.push({...message, ...{aircraft_code: target}});
    })
    return list;
  }
});

export const setCoPiPositionDataAllSelector = selector({
  key: 'setCoPiPositionDataAllSelector',
  set: ({get, set}, newValue) => {
    const oldValue = get(coPiPositionDataAll);
    if (!isEqualObject(oldValue, newValue)) {
      set(coPiPositionDataAll, newValue);
    }
  },
  get: () => {}
});

const tooltipSettingUrl = `pri/conf/data/CoPiTooltipSettings.json`;
const _getTooltipSettings = async () => {
	const config = {
		method: 'GET',
		url: tooltipSettingUrl,
		params: {
			't': Date.now(),
		},
		errorHandle: {
			message: COMMUNICATE_ERROR_COPILOT_TOOLTIP_SETTINGS
    }
	};

	return await axios(config)
		.then(response => {
			return response.data;
		})
		.catch(e => {
		});
};

export const coPiTooltipSettings = selector({
  key: 'coPiTooltipSettings',
	get: () => {
		return new Promise(resolve => requestIdleCallback(async () => {
			const data = await _getTooltipSettings();
			resolve(data);
		}))
  }
});

export const csTargetSelectState = atom({
  key: 'csTargetSelectState',
  default: ''
});
